import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import testimonialImage from '../../../assets/testimonial1.jpg';
import testimonialImage2 from '../../../assets/testimonial2.jpg';
import testimonialImage3 from '../../../assets/testimonial3.jpg';
import testimonialImage4 from '../../../assets/testimonial4.jpg';
// import 'swiper/css';
// import 'swiper/css/pagination';
// import 'swiper/css/effect-fade';
import css from './PromotionalContent.module.css';
import OwnerGroup from '../../../assets/ownersGroup.png';
import classNames from 'classnames';
import { NamedLink } from '../../../components';

const PromotionalContent = ({ isLogin = false, intl }) => {
    const [swiperComponents, setSwiperComponents] = useState(null);
    const [swiperModules, setSwiperModules] = useState(null);

    // Dynamically load Swiper components to avoid SSR issues with ES module
    useEffect(() => {
        let isMounted = true;

        const loadSwiper = async () => {
            try {
                const [{ Swiper, SwiperSlide }, { Pagination, Autoplay, EffectFade }] = await Promise.all([
                    import(/* webpackChunkName: "swiper-react" */ 'swiper/react'),
                    import(/* webpackChunkName: "swiper-modules" */ 'swiper/modules'),
                ]);

                if (isMounted) {
                    setSwiperComponents({ Swiper, SwiperSlide });
                    setSwiperModules({ Pagination, Autoplay, EffectFade });
                }
            } catch (error) {
                console.error('Failed to load Swiper:', error);
            }
        };

        loadSwiper();

        return () => {
            isMounted = false;
        };
    }, []);

    const swiperReady = swiperComponents && swiperModules;

    return (
        <div className={classNames(css.container, isLogin && css.loginContainer)}>
            <div
                key={isLogin ? 'login' : 'signup'}
                className={isLogin ? css.contentWrapper : css.contentWrapperSignup}
            >
                <div className={css.heroSection}>
                    {!isLogin && <h1 className={css.heroTitle}>
                        {/* {isLogin ? (
                        <>
                            <FormattedMessage id="PromotionalContent.loginTitle" defaultMessage="Welcome Back!" />
                        </>
                    ) : (
                        <> */}
                        <FormattedMessage id="PromotionalContent.signupTitle" defaultMessage="Rent" />
                        &nbsp;<span className={css.highlight}>
                            <FormattedMessage id="PromotionalContent.signupTitleAnything" defaultMessage="Anything" />
                        </span>
                        ,
                        <br />
                        <FormattedMessage id="PromotionalContent.signupTitleHighlight" defaultMessage=" Anytime, Anywhere" />
                        {/* </>
                    )} */}
                    </h1>}
                    {!isLogin && <p className={css.heroDescription}>
                        {/* {isLogin ? (
                        <FormattedMessage
                            id="PromotionalContent.loginDescription"
                            defaultMessage="Log in with the details you used to sign up."
                        />
                    ) : ( */}
                        <FormattedMessage
                            id="PromotionalContent.signupDescription"
                            defaultMessage="Join thousands of people who are already earning money by renting out their items or finding exactly what they need for their next project."
                        />
                        {/* )} */}
                    </p>}
                </div>

                {!isLogin && (
                    <>
                        <div className={css.featureList}>
                            {/* <h3 className={css.featureListTitle}>
                            <FormattedMessage id="PromotionalContent.benefitsTitle" defaultMessage="Key Benefits" />
                        </h3> */}
                            <ul className={css.featureListItems}>
                                <li className={css.featureItem}>
                                    <span className={css.checkmark}><i className="ri-checkbox-circle-fill"></i></span>
                                    <FormattedMessage
                                        id="PromotionalContent.benefit1"
                                        defaultMessage="Earn money by listing items you're not using"
                                    />
                                </li>
                                <li className={css.featureItem}>
                                    <span className={css.checkmark}><i className="ri-checkbox-circle-fill"></i></span>
                                    <FormattedMessage
                                        id="PromotionalContent.benefit2"
                                        defaultMessage="Join for free—no setup or listing fees"
                                    />
                                </li>
                                <li className={css.featureItem}>
                                    <span className={css.checkmark}><i className="ri-checkbox-circle-fill"></i></span>
                                    <FormattedMessage
                                        id="PromotionalContent.benefit3"
                                        defaultMessage="Safe, secure, and always supported"
                                    />
                                </li>
                            </ul>
                        </div>

                        <div className={css.testimonialSection}>
                            <h3 className={css.testimonialTitle}>
                                <FormattedMessage id="PromotionalContent.testimonialTitle" defaultMessage="What our users say" />
                            </h3>
                            {swiperReady && (
                                <div className={css.testimonialCard}>
                                    <swiperComponents.Swiper
                                        modules={[swiperModules.Pagination, swiperModules.Autoplay, swiperModules.EffectFade]}
                                        effect="fade"
                                        fadeEffect={{ crossFade: true }}
                                        spaceBetween={20}
                                        slidesPerView={1}
                                        pagination={{
                                            clickable: true,
                                            bulletClass: css.swiperBullet,
                                            bulletActiveClass: css.swiperBulletActive
                                        }}
                                        autoplay={{
                                            delay: 2000,
                                            disableOnInteraction: false,
                                        }}
                                        className={css.testimonialSwiper}
                                    >
                                        <swiperComponents.SwiperSlide>
                                            <div className={css.rating}>★★★★★</div>
                                            <blockquote className={css.testimonialQuote}>
                                                <FormattedMessage
                                                    id="PromotionalContent.testimonial1Quote"
                                                    defaultMessage="Planning our outdoor party was stress-free — we found tents, heaters, and décor all in one place. Highly recommend!"
                                                />
                                            </blockquote>
                                            <div className={css.userInfo}>
                                                <div className={css.userAvatar}>
                                                    <div className={css.avatarPlaceholder}>
                                                        <img src={testimonialImage} alt="Alicia Fernandez" loading="lazy" />
                                                    </div>
                                                </div>
                                                <div className={css.userDetails}>
                                                    <div className={css.userName}>
                                                        <FormattedMessage id="PromotionalContent.testimonial1UserName" defaultMessage="Alicia Fernandez" />
                                                    </div>
                                                    <div className={css.userTitle}>
                                                        <FormattedMessage id="PromotionalContent.testimonial1UserTitle" defaultMessage="Event Planner – Ottawa, ON" />
                                                    </div>
                                                </div>
                                            </div>
                                        </swiperComponents.SwiperSlide>

                                        <swiperComponents.SwiperSlide>
                                            <div className={css.rating}>★★★★★</div>
                                            <blockquote className={css.testimonialQuote}>
                                                <FormattedMessage
                                                    id="PromotionalContent.testimonial2Quote"
                                                    defaultMessage="Instead of buying tools I'd only use once, I rented everything I needed for my home project. Saved money and storage space!"
                                                />
                                            </blockquote>
                                            <div className={css.userInfo}>
                                                <div className={css.userAvatar}>
                                                    <div className={css.avatarPlaceholder}>
                                                        <img src={testimonialImage2} alt="Alicia Fernandez" loading="lazy" />
                                                    </div>
                                                </div>
                                                <div className={css.userDetails}>
                                                    <div className={css.userName}>
                                                        <FormattedMessage id="PromotionalContent.testimonial2UserName" defaultMessage="Daniel Morris" />
                                                    </div>
                                                    <div className={css.userTitle}>
                                                        <FormattedMessage id="PromotionalContent.testimonial2UserTitle" defaultMessage="Home Renovator – Calgary, AB" />
                                                    </div>
                                                </div>
                                            </div>
                                        </swiperComponents.SwiperSlide>

                                        <swiperComponents.SwiperSlide>
                                            <div className={css.rating}>★★★★★</div>
                                            <blockquote className={css.testimonialQuote}>
                                                <FormattedMessage
                                                    id="PromotionalContent.testimonial3Quote"
                                                    defaultMessage="I rented a high-end camera for a weekend shoot at a fraction of the purchase cost. The process was quick, and the owner was so helpful."
                                                />
                                            </blockquote>
                                            <div className={css.userInfo}>
                                                <div className={css.userAvatar}>
                                                    <div className={css.avatarPlaceholder}>
                                                        <img src={testimonialImage3} alt="Alicia Fernandez" loading="lazy" />
                                                    </div>
                                                </div>
                                                <div className={css.userDetails}>
                                                    <div className={css.userName}>
                                                        <FormattedMessage id="PromotionalContent.testimonial3UserName" defaultMessage="Sophie Grant" />
                                                    </div>
                                                    <div className={css.userTitle}>
                                                        <FormattedMessage id="PromotionalContent.testimonial3UserTitle" defaultMessage="Freelance Photographer – Vancouver, BC" />
                                                    </div>
                                                </div>
                                            </div>
                                        </swiperComponents.SwiperSlide>

                                        <swiperComponents.SwiperSlide>
                                            <div className={css.rating}>★★★★★</div>
                                            <blockquote className={css.testimonialQuote}>
                                                <FormattedMessage
                                                    id="PromotionalContent.testimonial4Quote"
                                                    defaultMessage="Rented a carpet cleaner for a weekend deep clean — way cheaper than hiring a service, and the results were amazing!"
                                                />
                                            </blockquote>
                                            <div className={css.userInfo}>
                                                <div className={css.userAvatar}>
                                                    <div className={css.avatarPlaceholder}>
                                                        <img src={testimonialImage4} alt="Alicia Fernandez" loading="lazy" />
                                                    </div>
                                                </div>
                                                <div className={css.userDetails}>
                                                    <div className={css.userName}>
                                                        <FormattedMessage id="PromotionalContent.testimonial4UserName" defaultMessage="Rachel Adams" />
                                                    </div>
                                                    <div className={css.userTitle}>
                                                        <FormattedMessage id="PromotionalContent.testimonial4UserTitle" defaultMessage="Busy Mom – Halifax, NS" />
                                                    </div>
                                                </div>
                                            </div>
                                        </swiperComponents.SwiperSlide>
                                    </swiperComponents.Swiper>
                                </div>
                            )}
                        </div>

                        <div className={css.trustIndicators}>
                            <img src={OwnerGroup} alt={intl.formatMessage({ id: 'PromotionalContent.ownerGroupAlt' })} loading="lazy" />
                            <p className={css.trustText}>
                                <FormattedMessage id="PromotionalContent.trustText" defaultMessage="Trusted by renters and owners across the globe" />
                            </p>
                            <div className={css.stars}>★★★★★</div>
                        </div>
                    </>
                )}

                {isLogin && (
                    <div className={css.loginPromotional}>
                        <h2 className={css.loginPromoTitle}>
                            <FormattedMessage id="PromotionalContent.loginPromoTitle" defaultMessage="List. Rent." />
                            <b> <FormattedMessage id="PromotionalContent.loginPromoTitleRepeat" defaultMessage="Repeat." /></b>
                        </h2>
                        <p className={css.loginPromoDescription}>
                            <FormattedMessage
                                id="PromotionalContent.loginPromoDescription"
                                defaultMessage="Access thousands of items from your neighbors. From power tools to party supplies, find what you need without the commitment of buying."
                            />
                        </p>
                        <NamedLink name="CMSPage" params={{ pageId: 'learn_more' }} className={css.watchVideo}>
                            <div className={css.playButton}>
                                <i className='ri-lightbulb-flash-line'></i>
                            </div>
                            <div className={css.videoText}>
                                <div className={css.videoTitle}>
                                    <FormattedMessage id="PromotionalContent.watchVideoTitle" defaultMessage="Watch how it works" />
                                </div>
                                <div className={css.videoSubtitle}>
                                    <FormattedMessage id="PromotionalContent.watchVideoSubtitle" defaultMessage="See how easy it is to rent and lend items in your community" />
                                </div>
                            </div>
                        </NamedLink>
                        <div className={css.loginFeatureList}>
                            <div className={css.loginFeatureItem}>
                                <span className={css.checkmark}><i className="ri-checkbox-circle-fill"></i></span>
                                <FormattedMessage id="PromotionalContent.loginFeature1" defaultMessage="Save up to 80% compared to buying" />
                            </div>
                            <div className={css.loginFeatureItem}>
                                <span className={css.checkmark}><i className="ri-checkbox-circle-fill"></i></span>
                                <FormattedMessage id="PromotionalContent.loginFeature2" defaultMessage="Earn money from items you own" />
                            </div>
                            <div className={css.loginFeatureItem}>
                                <span className={css.checkmark}><i className="ri-checkbox-circle-fill"></i></span>
                                <FormattedMessage id="PromotionalContent.loginFeature3" defaultMessage="Safe, secure, and always supported" />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

PromotionalContent.propTypes = {
    isLogin: PropTypes.bool,
    intl: PropTypes.object.isRequired,
};

export default PromotionalContent;
